export const GET_WAITING_LIST_STATE = 'GET_WAITING_LIST_STATE'
export const SET_WAITING_LIST_STATE = 'SET_WAITING_LIST_STATE'
export const GET_WAITING_LIST_STATE_ERROR = 'GET_WAITING_LIST_STATE_ERROR'

export const SET_WAITLIST_ID = 'SET_WAITLIST_ID'

export const SUBSCRIBE_WAITING_LIST = 'SUBSCRIBE_WAITING_LIST'
export const SUCCESS_SUBSCRIBE_WAITING_LIST = 'SUCCESS_SUBSCRIBE_WAITING_LIST'

export const WAITLIST_STATE_PENDING = 'PENDING'
export const WAITLIST_STATE_FULFILLED = 'FULFILLED'
export const WAITLIST_STATE_REJECTED = 'ERROR'
export const CLEAR_WAITLIST_ERROR_STATE = 'CLEAR_WAITLIST_ERROR_STATE'
export const CLEAR_WAITLIST_STATE = 'CLEAR_WAITLIST_STATE'

export const WAITLIST_FLOW = 'waitinglist'
